import { useEffect } from 'react'

const PIXEL_ID = '1009578682058738'

type PixelFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  loaded?: boolean
  version?: string
  push?: unknown
}

declare global {
  interface Window {
    fbq?: PixelFn
    _fbq?: PixelFn
  }
}

function loadPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: PixelFn = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue?.push(args)
    }
  }

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}

export function useMetaPixel(): void {
  useEffect(() => {
    loadPixel()
    if (!window.fbq) return
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}
